import React from 'react'
import { Stack } from '@mui/material'
import { PATIENT_PANEL_WIDTH } from '../../../../config'
import { DoctorPatientProfile } from '../types/doctorPatients.types'
import { PatientContactsSection } from './DoctorPatientDetails/PatientContactsSection'
import { DoctorPatientDetailsHeader } from './DoctorPatientDetails/DoctorPatientDetailsHeader'
import { PatientBasicSection } from './DoctorPatientDetails/PatientBasicSection'
import { PatientMeasurementsSection } from './DoctorPatientDetails/PatientMeasurementsSection'
import { PatientContactDataSection } from './DoctorPatientDetails/PatientContactDataSection'

interface DoctorPatientDetailsProps {
  patientProfile: DoctorPatientProfile
  refetchPatientProfile: () => void
  setActiveTabIndex: (tab: number) => void
}

export const DoctorPatientDetails: React.FC<
  React.PropsWithChildren<DoctorPatientDetailsProps>
> = ({ patientProfile, refetchPatientProfile, setActiveTabIndex }) => {
  return (
    <Stack
      sx={{
        width: PATIENT_PANEL_WIDTH,
        minWidth: PATIENT_PANEL_WIDTH,
        height: '100%',
        backgroundColor: 'white',
        overflowY: 'auto',
        gap: 2,
      }}
      p={3}
    >
      <DoctorPatientDetailsHeader setActiveTabIndex={setActiveTabIndex} />

      <PatientBasicSection patientProfile={patientProfile} />

      <PatientMeasurementsSection
        patientProfile={patientProfile}
        refetchPatientProfile={refetchPatientProfile}
      />

      <PatientContactDataSection patientProfile={patientProfile} />

      <PatientContactsSection
        patientProfile={patientProfile}
        refetchPatientProfile={refetchPatientProfile}
      />
    </Stack>
  )
}
